;(function() {
/* @ngInject */
function IdentityDocumentsController($filter) {
  let vm = this;
  let today = new Date();
  today.setHours(0, 0, 0, 0);

  vm.dateFormat = "dd. MM. yyyy";
  vm.dateIssued = [];
  vm.dateValidUntil = [];
  vm.dateIssuedPopupOpened = [];
  vm.dateValidUntilPopupOpened = [];
  vm.dateIssuedOptions = [];
  vm.dateValidUntilOptions = [];
  let initializedModel = null;

  vm.$doCheck = () => {
    if (vm.model === initializedModel)
      return;
    if (!angular.isArray(vm.model))
      vm.model = [];

    while (vm.model.length < 2) {
      vm.model.push({
        docType: "",
        docId: "",
        issuer: "",
        dateIssued: "",
        dateValidUntil: ""
      });
    }

    removeDuplicateSupplementaryType();

    vm.model.slice(0, 2).forEach((document, index) => {
      // UI Bootstrap mutates picker options and initDate while navigating.
      // Keep each picker and its date limits independent.
      vm.dateIssuedOptions[index] = {
        showWeeks: false,
        initDate: new Date(today.getTime()),
        maxDate: new Date(today.getTime())
      };
      vm.dateValidUntilOptions[index] = {
        showWeeks: false,
        initDate: new Date(today.getTime()),
        minDate: new Date(today.getTime())
      };
      vm.dateIssued[index] = parseDate(document.dateIssued);
      vm.dateValidUntil[index] = parseDate(document.dateValidUntil);
      vm.dateIssuedPopupOpened[index] = false;
      vm.dateValidUntilPopupOpened[index] = false;
    });
    initializedModel = vm.model;
  };

  vm.onDocumentTypeChange = (index) => {
    if (index === 0)
      removeDuplicateSupplementaryType();
  };

  vm.onDateIssuedChange = (document, index) => {
    document.dateIssued = formatDate(vm.dateIssued[index]);
  };

  vm.onDateValidUntilChange = (document, index) => {
    document.dateValidUntil = formatDate(vm.dateValidUntil[index]);
  };

  function removeDuplicateSupplementaryType() {
    if (vm.model[0].docType && vm.model[1].docType === vm.model[0].docType)
      vm.model[1].docType = "";
  }

  function formatDate(date) {
    return angular.isDate(date) ? $filter("date")(date, "dd.MM.yyyy") : "";
  }

  function parseDate(value) {
    if (angular.isDate(value))
      return value;

    if (typeof value !== "string" || !value.trim())
      return null;

    let match = /^(\d{1,2})\.\s*(\d{1,2})\.\s*(\d{4})$/.exec(value.trim());
    if (match) {
      let date = new Date(Number(match[3]), Number(match[2]) - 1, Number(match[1]));
      if (date.getFullYear() === Number(match[3]) &&
          date.getMonth() === Number(match[2]) - 1 &&
          date.getDate() === Number(match[1]))
        return date;
    }

    let date = new Date(value);
    return isNaN(date.getTime()) ? null : date;
  }
}

angular.module("firmaren")
  .component("identityDocuments", {
    templateUrl: "/app/shared/identity-documents/identity-documents.html",
    controller: IdentityDocumentsController,
    controllerAs: "vm",
    bindings: {
      model: "=",
      form: "<",
      submitted: "<",
      idPrefix: "@"
    }
  });
}());
